import { useMemo } from "react";
import { create } from "zustand";

type ClockStore = {
  diff: number;
  setDay: (time: Date) => void;
  reset: () => void;
};

const useClockStore = create<ClockStore>((set) => ({
  diff: 0,
  setDay: (time: Date) => {
    const now = new Date();
    now.setHours(0, 0, 0, 0);
    time = new Date(time);
    time.setHours(0, 0, 0, 0);
    set({ diff: time.valueOf() - now.valueOf() });
  },
  reset: () => {
    set({ diff: 0 });
  },
}));

export const useClock = () => {
  const { diff, setDay, reset } = useClockStore();
  const now = useMemo(() => Date.now() + diff, [diff]);
  const date = useMemo(() => new Date(now), [now]);
  return { now, date, setDay, reset };
};
